import React, { lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

const LoginPage = lazy(() => import('@features/auth/LoginPage'));
const RegisterPage = lazy(() => import('@features/auth/RegisterPage'));
const CompleteProfilePage = lazy(() => import('@features/auth/CompleteProfilePage'));
const NotFoundPage = lazy(() => import('@/components/common/NotFoundPage'));

import { useAppSelector } from '@/hooks';

const AuthRoutes: React.FC = () => {
    const { isAuthenticated, mustChangePassword } = useAppSelector((state) => state.auth);
    
    // Only redirect if user is actually authenticated in Redux state
    // Don't redirect based on token alone, as token might be invalid
    if (isAuthenticated) {
        if (mustChangePassword) {
            return <Navigate to="/change-password-required" replace />;
        }
        return <Navigate to="/student/dashboard" replace />;
    }
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/complete-profile" element={<CompleteProfilePage />} />
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
};

export default AuthRoutes;
